export default __webpack_public_path__ + "static/media/include_5@3x.8365c320.jpg";